<template>
  <div class="container">
    <div class="handle-wrapper">
      <Modal
        v-model="deleteCustomerDevelopModal"
        title="删除新客户开发"
        @on-ok="deleteCustomerDevelopMethod"
      >
        <div>确认要删除此条新客户开发吗？</div>
      </Modal>
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomerDevelop"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 30px"
        >
        </Input>
        <Select
          placeholder="状态筛选"
          v-model="selectedStatu"
          label-in-value
          clearable
          @on-change="choseStatus"
          style="width: 150px"
        >
          <Option
            v-for="item in status"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <!-- 开发人员筛选 -->
        <Select
          v-model="salesVisible"
          clearable
          filterable
          @on-open-change="getSearchList"
          @on-change="choseSalesVisible"
          @on-query-change="filterUserList"
          style="width: 150px; margin: 0 10px"
          placeholder="开发人员筛选"
        >
          <Option
            v-for="item in salesVisibleMember"
            :value="item._id"
            :key="item._id"
            >{{ item.name }}</Option
          >
        </Select>
        <!-- 城市筛选 -->
        <Cascader
          :data="pca"
          placeholder="城市筛选"
          @on-visible-change="showCity"
          :render-format="citySelect"
          @on-change="chooseCity"
          change-on-select
          style="width: 280px"
        ></Cascader>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="15"
            @on-change="loadCustomerDevelop"
            show-total
            simple
          />
        </div>
        <Button
          @click="$refs.UploadFileModal.openModal()"
          style="margin-right: 15px"
          v-if="arrayIntersection(['salesAssist'], user.simpleRole).length > 0"
          >导入已开发用户</Button
        >
        <Button type="primary" @click="openCreateCustomerDevelopDrawer()"
          >新增客户开发</Button
        >
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      >
        <template slot-scope="{ row }" slot="content">
          <Poptip
            placement="bottom"
            word-wrap
            width="400"
            trigger="hover"
            :content="row.content"
          >
            <p class="content-item">{{ row.content }}</p>
          </Poptip>
        </template>
        <template slot-scope="{ row }" slot="operate">
          <Dropdown trigger="hover" @on-click="clickActionDropDown" transfer>
            <a>
              操作
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <div>
                <DropdownItem
                  :name="`Delete,${row._id},${row.status}`"
                  style="color: #ed4014"
                  >删除</DropdownItem
                >
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
    </div>
    <CustomerDevelopDrawer
      :indexFilter="filterQuery"
      ref="CustomerDevelopDrawer"
    />
    <UploadFileModal ref="UploadFileModal" />
    <CreateCustomerDevelop
      :loadCustomerDevelop="loadCustomerDevelop"
      ref="CreateCustomerDevelop"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions, mapGetters } from "vuex";
import CustomerDevelopDrawer from "./CustomerDevelopDrawer.vue";
import CreateCustomerDevelop from "./CreateCustomerDevelop.vue";
import UploadFileModal from "./UploadFileModal.vue";
import { CityList } from "../../utils/pca.js";
import { arrayIntersection } from "@/utils";
import _ from "lodash";

const statusToText = {
  applying: "申请中",
  agree: "已同意",
  refuse: "已拒绝",
  expired: "已过期",
  success: "开发完成",
  abandon: "已放弃",
};
export default {
  name: "CustomerDevelopPage",
  components: {
    CustomerDevelopDrawer,
    CreateCustomerDevelop,
    UploadFileModal,
  },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      tableHeight: 300,
      status: [
        {
          value: "applying",
          label: "申请中",
        },
        {
          value: "agree",
          label: "已同意",
        },
        {
          value: "refuse",
          label: "已拒绝",
        },
        {
          value: "abandon",
          label: "已放弃",
        },
        {
          value: "success",
          label: "开发完成",
        },
        {
          value: "expired",
          label: "已过期",
        },
      ],
      selectedStatu: "",
      salesVisible: "",
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            ),
        },
        {
          title: "客户名字",
          key: "code",
          width: 500,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.$refs.CustomerDevelopDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.customer.name
              ),
            ]);
          },
        },
        {
          title: "内容",
          key: "remark",
          minWidth: 200,
          render: (h, params) => {
            return h("div", params.row.remark);
          },
        },
        {
          title: "开发途径",
          key: "developMethod",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("div", params.row.developMethod);
          },
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", statusToText[params.row.status]);
          },
        },
        {
          title: "申请人",
          key: "responsiblePerson",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", params.row.responsiblePerson.name);
          },
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", params.row.createdBy.name);
          },
        },
        {
          title: "截止时间",
          key: "endTime",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.expiredAt).format("YYYY年MM月DD日")
            );
          },
        },
        {
          title: "创建时间",
          key: "createdAt",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.createdAt).format("YYYY年MM月DD日 HH:mm")
            );
          },
        },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          width: 100,
        },
      ],
      currentCustomerDevelop: undefined,
      currentStatus: undefined,
      deleteCustomerDevelopModal: false,
      pca: [],
      filterQuery: { limit: 15 },
      salesVisibleMember: [],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.customerDevelop.customerDevelops,
      totalRows: (state) => state.customerDevelop.totalCounts,
      userList: (state) => state.user.userList,
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getCustomerDevelop: "customerDevelop/getCustomerDevelopAction",
      deleteCustomerDevelop: "customerDevelop/deleteCustomerDevelopAction",
      getUsersList: "user/getUsersAction",
    }),
    async loadCustomerDevelop(page) {
      const id = this.$route.query.id;
      this.filterQuery.customer = id;
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        skip: this.page * 15,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        await this.getCustomerDevelop(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },

    searchCustomerDevelop: _.debounce(function () {
      this.page = 0;
      this.loadCustomerDevelop();
    }, 1000),
    // 下拉菜单
    async choseStatus(status) {
      if (status) {
        this.filterQuery.status = status.value;
      } else {
        delete this.filterQuery.status;
      }
      this.loadCustomerDevelop();
    },

    async getSearchList(open) {
      if (open) {
        try {
          const userList = await this.getUsersList();
          let salesVisibleMember = userList.userList.filter((x) => {
            return (
              this.user.superAdmin ||
              arrayIntersection(
                ["sales", "salesAssist", "salesDirector", "salesLead"],
                x.simpleRole
              ).length > 0
            );
          });
          this.salesVisibleMember = salesVisibleMember;
        } catch (error) {
          this.$Message.error(`加载失败: ${error}`);
        }
      }
    },
    async filterUserList(searchSale) {
      try {
        const userList = await this.getUsersList({ userName: searchSale });
        let salesVisibleMember = userList.userList.filter((x) => {
          return (
            this.user.superAdmin ||
            arrayIntersection(
              ["sales", "salesAssist", "salesDirector", "salesLead"],
              x.simpleRole
            ).length > 0
          );
        });
        this.salesVisibleMember = salesVisibleMember;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
      }
    },
    // 选中开发人员
    async choseSalesVisible(responsiblePerson) {
      if (responsiblePerson) {
        this.filterQuery.responsiblePerson = responsiblePerson;
      } else {
        delete this.filterQuery.responsiblePerson;
      }
      this.loadCustomerDevelop();
    },

    showCity() {
      this.pca = CityList;
    },
    // 城市选择器
    citySelect(labels) {
      if (labels && labels.length > 0) {
        [
          this.filterQuery.province,
          this.filterQuery.city,
          this.filterQuery.dist,
        ] = [labels[0].slice(0, labels[0].length - 1), labels[1], labels[2]];
      } else {
        delete this.filterQuery.province;
        delete this.filterQuery.city;
        delete this.filterQuery.dist;
      }
      return labels.join(" ");
    },
    chooseCity(city) {
      this.loadCustomerDevelop();
    },
    // 操作按钮
    clickActionDropDown(name) {
      // 现在只有删除
      let operateInfo = name.split(",");
      [this.currentCustomerDevelop, this.currentStatus] = [
        operateInfo[1],
        operateInfo[2],
      ];
      this.deleteCustomerDevelopModal = true;
    },
    // 删除新客户开发
    async deleteCustomerDevelopMethod() {
      try {
        await this.deleteCustomerDevelop({
          id: this.currentCustomerDevelop,
          status: this.currentStatus,
        });
        await this.loadCustomerDevelop();
      } catch (error) {
        this.$Message.error(`删除失败: ${error}`);
      }
    },

    openCreateCustomerDevelopDrawer() {
      this.$refs.CreateCustomerDevelop.openDrawer();
    },
  },
  created() {
    this.loadCustomerDevelop();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)

.add-customer
  margin-right 12px
</style>